import type {Type} from '@packages/systems/wfdl';

import {isModalAction, type ModalAction} from './constants';
import {isModalTarget, isModalTargetType} from './target';
import {getModalDomId} from './ids';
import {
  defineOverlayTargetContext,
  OverlayTargetContextType,
  type OverlayKindConfig,
  type OverlayTarget,
} from '../shared/targetContext';

export type ModalTargetFactory = (action: unknown) => {
  mode: 'modal';
  modalAction: ModalAction;
  modalTarget?: OverlayTarget;
};

export type ModalTargetContext = (
  componentKey: string
) => (targetId: string) => ModalTargetFactory;

const createModalTargetFactory =
  (modalTarget?: OverlayTarget): ModalTargetFactory =>
  (action) => {
    const modalAction = isModalAction(action) ? action : 'show';
    return modalTarget === undefined
      ? {mode: 'modal', modalAction}
      : {mode: 'modal', modalAction, modalTarget};
  };

const modalKindConfig: OverlayKindConfig<ModalTargetFactory> = {
  isTarget: isModalTarget,
  isTargetType: isModalTargetType,
  getDomId: getModalDomId,
  createTargetFactory: createModalTargetFactory,
  fallbackTargetFactory: createModalTargetFactory(),
};

export const ModalTargetContextType: Type = OverlayTargetContextType;

export const {
  buildContext: buildModalTargetContext,
  createContextRef: createModalTargetContextRef,
} = defineOverlayTargetContext(modalKindConfig);
